<template>
  <HomeworkApproveDetail :report="report">
    <template slot="left">
      <div class="question-wrap">
        <div class="title">作业内容</div>
        <Tabs class="ques-tab" :value="type" @on-click="onTabClick">
          <TabPane label="全部" name="all"></TabPane>
          <TabPane label="简答题" name="subjective"></TabPane>
          <TabPane label="客观题" name="objective"></TabPane>
        </Tabs>
        <HomeworkPreviewQuestion
          v-for="(ques,index) in filterList"
          :id="index+1"
          :key="ques.id"
          :ques="ques"
          :readonly="true"
          :hasAnalysis="true"
          :index="index+1"
          :showCollapse="false"
          :hasCorrectTag="true"
          class="ques-homework"
        ></HomeworkPreviewQuestion>
      </div>
    </template>
    <template slot="right">
      <div class="answer-view">
        <div class="progress">
          <span>答题卡</span>
          <span class="primary-color">{{answerCount}}</span>
          <span>/{{total}}</span>
        </div>
        <div class="nums">
          <a
            class="num"
            :class="{'right':answerState[key]==1,'error':answerState[key]==0,'none':answerState[key]==0,'reviewing':answerState[key]=='reviewing','review':answerState[key]=='review'}"
            :key="key"
            v-for="(value,key) in answerState"
            @click="scrollTo(key)"
          >{{key}}</a>
        </div>
        <div class="legend">
          <span class="num right"></span>
          <span>正确{{rightCount}}</span>
          <span class="num error"></span>
          <span>错误{{errorCount}}</span>
          <span class="num review"></span>
          <span>已批阅{{reviewCount}}</span>
          <span class="num none"></span>
          <span>未做{{noneCount}}</span>
        </div>
      </div>
    </template>
  </HomeworkApproveDetail>
</template>
<script>
import HomeworkApproveDetail from "@/components/Homework/HomeworkApproveDetail.vue";
import HomeworkPreviewQuestion from "@/components/Homework/HomeworkPreviewQuestion.vue";
export default {
  name: "StudentHomeworkApprove",
  components: {
    HomeworkApproveDetail,
    HomeworkPreviewQuestion
  },
  computed: {
    filterList() {
      if (this.type == "all") {
        return this.list;
      } else if (this.type == "subjective") {
        return this.list.filter(q => q.ques_type == 5);
      } else {
        return this.list.filter(q => q.ques_type != 5);
      }
    }
  },
  data() {
    return {
      report_id: this.$route.query.reportId,
      student_id: this.$route.query.student_id,
      type: "all",
      list: [],
      total: 0,
      answerCount: 0,
      answerState: {},
      rightCount: 0,
      errorCount: 0,
      noneCount: 0,
      reviewCount: 0,
      chars: { 1: "A", 2: "B", 3: "C", 4: "D", 5: "E", 6: "F" },
      report: {}
    };
  },
  async created() {
    let data = await this.$http.get(
      "/api/classHomework/detail/student/" +
        this.report_id +
        "/" +
        this.student_id
    );
    data.question.forEach(ques => {
      if (ques.ques_option && typeof ques.ques_option == "string") {
        ques.ques_option = JSON.parse(ques.ques_option);
      }
    });
    this.list = data.question;
    this.report = data.report_base;
  },
  watch: {
    filterList() {
      let index = 1;
      let answerState = {};
      let answerCount = 0;
      let noneCount = 0;
      let rightCount = 0;
      let errorCount = 0;
      let reviewCount = 0;
      this.filterList.forEach(ques => {
        ques.index = index;
        let answers = [];
        if (ques.user_answer) {
          let user_answer;
          if (typeof ques.user_answer === "string") {
            user_answer = JSON.parse(ques.user_answer);
          } else {
            user_answer = ques.user_answer;
          }
          if (ques.ques_type != 5) {
            user_answer.forEach(a => {
              if (ques.ques_type == 4) {
                if (a.answer) {
                  answers.push(a.id + ")" + this.chars[a.answer] + " ");
                }
              } else {
                if (a.id) {
                  answers.push(this.chars[a.id]);
                }
              }
            });
          }
        }
        if (ques.ques_type != 5) {
          if (answers.length > 0) {
            answerCount++;
            if (ques.is_right == 1) {
              rightCount++;
            } else {
              errorCount++;
            }
            answerState[ques.index] = ques.is_right == 1 ? 1 : 0;
          } else {
            answerState[ques.index] = -1;
            noneCount++;
          }
        } else {
          if (ques.user_answer.length == 0) {
            noneCount++;
            answerState[ques.index] = -1;
          } else {
            answerCount++;
            if (ques.review_status == 2) {
              reviewCount++;
              answerState[ques.index] = "review";
            } else {
              answerState[ques.index] = "reviewing";
            }
          }
        }
        index++;
      });
      this.answerCount = answerCount;
      this.noneCount = noneCount;
      this.rightCount = rightCount;
      this.errorCount = errorCount;
      this.reviewCount = reviewCount;
      this.total = index - 1;
      this.answerState = answerState;
    }
  },
  methods: {
    scrollTo(id) {
      let $ = window.$;
      let $ele = $("#" + id);
      if ($ele.length == 0) {
        return;
      }
      let top = $ele.offset().top - 84;
      $(".v-view").scrollTop(top);
    },
    onTabClick(tab) {
      this.type = tab;
    }
  }
};
</script>
<style lang="scss" scoped>
.question-wrap {
  padding: 24px 0;
  .title {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(38, 38, 38, 1);
    line-height: 16px;
    position: relative;
    padding-left: 11px;
    margin-bottom: 15px;
    margin-left: 24px;
    &::before {
      position: absolute;
      content: "";
      width: 3px;
      height: 14px;
      background: $primary-color;
      border-radius: 2px;
      top: 7px;
      left: 0;
    }
  }
}
.ques-homework {
  padding-top: 39px;
  /deep/ {
    .icon-result {
      top: 65px;
    }
  }
}
.ques-tab {
  padding: 5px 24px 0 24px;
  /deep/ {
    .el-tabs__header {
      margin-bottom: 0;
    }
    .el-tabs__item {
      color: #595959;
      height: 50px;
      line-height: 50px;
    }
  }
}
.answer-view {
  box-sizing: border-box;
  border-radius: 5px;
  .progress {
    background: rgba(247, 247, 247, 1);
    padding: 10px;
    font-size: 16px;
    .primary-color {
      font-size: 18px;
    }
  }
  .nums {
    background-color: white;
    padding: 0 12px 12px 12px;
    margin-bottom: 15px;
  }
  .num {
    width: 24px;
    height: 24px;
    line-height: 24px;
    display: inline-block;
    text-align: center;
    border: 1px solid rgba(232, 232, 232, 1);
    border-radius: 3px;
    color: #b8b8b8;
    margin-top: 12px;
    margin-right: 12px;
    cursor: pointer;
    &.right {
      background-color: #30c596;
      color: white;
    }
    &.error {
      background-color: #ff5500;
      color: white;
    }
    &.reviewing {
      border-color: $primary-color;
      color: $primary-color;
    }
    &.review {
      background-color: $primary-color;
      color: white;
    }
    &:nth-child(7) {
      margin-right: 0;
    }
  }
  .legend {
    background-color: white;
    padding: 13px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 24px;
    .num {
      margin-top: 0;
      margin-right: 5px;
      width: 14px;
      height: 14px;
      cursor: default;
    }
    span:nth-child(2),
    span:nth-child(4),
    span:nth-child(6) {
      margin-right: 25px;
    }
  }
}
</style>